import styled from '@emotion/styled';
import {Button as ButtonUI} from '@travel-frontend/ui-components';

export const Button = styled(ButtonUI)`
  width: 100%;
  max-width: 343px;
`;
